import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  styled,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import ToastPopup from "../ToastPopup";
import { scenarioaBack } from "../../Redux/Actions/InputData";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function NameTheScenario(props: any) {
  // console.log(props, "upload values")

  const BackToSelectDataUpload = () => {
    //console.log("BackToSelectDataUpload")
     dispatch(scenarioaBack());
   };
  const isScenarioExisted = useSelector(
    (state: any) => state.InputDataReducers.isScenarioExisted
  );

  const dispatch = useDispatch();

  const scenarioNumber = useSelector(
    (state: any) => state.InputDataReducers.scenarioNumber
  );

  if(scenarioNumber) {
    //console.log('scenarioNumber: ', scenarioNumber);
  }

  return (
    <>
      <BootstrapDialog
        onClose={props.BackToSelectDataUpload}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <div className="modal-header">
          <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
              <h3>{"Select data to upload"}</h3>
              <p className="sub-title-text">{"Get started with optimisation."}</p>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <CancelIcon
                className="cancel-icon"
                onClick={props.BackToSelectDataUpload}
              />
            </Grid>
          </Grid>
        </div>
        <DialogContent className="modal-body">
          <div className="create-folder">
            <div>
              <label>Scenario number</label>
              <TextField
                id="scenario_number"
                placeholder="Enter Scenario number"
                className="create-folder-text"
                variant="outlined"
                type="number"
                value={props.inputScenarioNumber | scenarioNumber}
                onChange={props.handleInputScenarioNumber}
              />
            </div>
            <div>
              <label>Add Scenario name*</label>
              <TextField
                id="scenario_name"
                placeholder="Enter Scenario name"
                className="create-folder-text"
                variant="outlined"
                value={props.inputScenarioName}
                onChange={props.handleInputScenarioName}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="modal-action">
            <Button
              variant="outlined"
              className="cancel"
              onClick={BackToSelectDataUpload}
            >
              Go back
            </Button>
            {props.inputScenarioName ? (  <Button
              variant="contained"
              className="Next"
              onClick={props.handleNextNameScenario}
            >
              Next
            </Button>) : (
               <Button
               variant="contained"
               className="disabled-proc-btn"
             >
               Next
             </Button>
            )}
          </div>
        </DialogActions>
        {isScenarioExisted && (
          <ToastPopup message={'Folder is existed'} type="error" />
        )}
      </BootstrapDialog>
    </>
  );
}

export default NameTheScenario;
